import { render, staticRenderFns } from "./FormationDetailParameter.vue?vue&type=template&id=a9c68c88"
import script from "./FormationDetailParameter.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormationDetailParameter.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports